import styled from "@emotion/styled";

export const MyCardTwo = {
    block: styled.div`
        overflow: hidden;
        box-sizing: border-box;
        position: relative;
        border: solid 1px #DCDCDC;
        border-radius: 24px;
        background: #F5F5F5;
        margin-right: 20px;
        color: #3B3B3B;
        min-height: 100%;
        
        &.purple {
            background-color: #631D63;
            border-color: #631D63;
            color: white;
        }
    `,
    
    wrapper: styled.div`
        padding: 20px;
        display: grid;
        gap: 20px;
        
        @media ( min-width: 361px) {
            padding: 25px;
            gap: 25px;
        }
        
        @media ( min-width: 769px) {
            padding: 32px;
            gap: 32px;
        }
    `,

    title: styled.h3`
        font-family: 'Shell Heavy';
        line-height: 120%;
        font-size: 18px;
        margin: 0;
            
        @media ( min-width: 361px) {
            font-size: 29px;
        }

        @media ( min-width: 769px) {
            font-size: 32px;
        }
    `,
    
    text: styled.div`
        min-height: 113px;
        gap: 20px;

        p {
            font-size: 12px;
            line-height: 160%;
            letter-spacing: 0%;
            font-family: 'Shell Book';
            margin: 0;

            @media ( min-width: 361px) {
                font-size: 14px;
            }

            @media ( min-width: 769px) {
                font-size: 16px;
            }
        }

        strong {
            font-family: 'Shell Heavy';
        }
        
        .purple & {
            strong {
                color: #F8CD05;
            }
        }
    `,

    wraoImage: styled.figure`
        width: 100%;
        margin: 0;
    `,

    image: styled.img`
        display: block;
        max-width: 100%;
    `,
    
    CTA: styled.a`
        font-family: 'Shell Medium';
        text-decoration: none;
        text-align: center;
        width: fit-content;
        border-radius: 8px;
        display: block;
        padding: 13px 20px;
        line-height: 17px;
        font-size: 14px;

        :hover {
            text-decoration: underline;
        }

        @media ( min-width: 769px) {            
            line-height: 23.15px;
            font-size: 17.36px;
            padding: 17px 27px;
        }

        background-color: #FFBD2F;
        color: #3B3B3B;

        .purple & {
            background-color: #FFBD2F;
            color: #631D63;
        }
    `,
}